import Papa from 'papaparse';

function convertToCSV(data) {
  const csv = Papa.unparse(data);
  return csv;
}
  
export default convertToCSV;